module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-返回-暗.5206c.png";